// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  OnChanges,
  output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SpModalFilters } from '../model/sp-modal-filters';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-spare-parts-filter-popover',
  templateUrl: './spare-parts-filter-popover.component.html',
  styleUrl: './spare-parts-filter-popover.component.scss',
})
export class SparePartsFilterPopoverComponent implements OnChanges {
  targetId = input.required<string>();
  modalFilters = input.required<SpModalFilters>();
  position = input<string>('');
  cancelChange = output<void>();
  modalFiltersChange = output<SpModalFilters>();

  readonly filterModelKeys = computed(() => {
    const filters = this.modalFilters();
    return filters ? Object.keys(filters) : [];
  });

  readonly clonedModalFilters = computed<SpModalFilters>(() => {
    return this.modalFilters().clone();
  });

  public ngOnChanges(changes: SimpleChanges): void {
    const value = changes['targetId']?.currentValue;
    if (value === undefined || value === null) {
      throw new Error('You should provide a targetId value');
    }

    const model = changes['modalFilters']?.currentValue;
    if (model === undefined || model === null) {
      throw new Error('You should provide a modalFilters value');
    }
  }

  protected onApplyFilterClick(): void {
    this.modalFiltersChange.emit(this.clonedModalFilters());
  }

  protected onCancelFilterClick(): void {
    this.cancelChange.emit();
  }

  protected onClickClearAll(): void {
    this.clonedModalFilters().clearAll();
    this.modalFiltersChange.emit(this.clonedModalFilters());
  }
}
